// Angular + external
import {
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Injector,
  NgZone,
  ViewEncapsulation,
} from "@angular/core";

// BFX
import { BfxBaseBlotter, provideBlotter } from "../bfx-base-blotter/bfx-base-blotter";
import { TranslateService } from "@ngx-translate/core";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";
import { BfxBlotterFilterService } from "../bfx-blotter-filter/bfx-blotter-filter.service";
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";

// form workers
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  SystemConfigPromiseService,
  ProfilePromiseActionService,
  ConnectionMonitorAuditTableDefinitionFactory,
} from "shared/cubiq-services";
import { BfxMouseModifierKeyService } from "../bfx-common/services/bfx-mouse-modifier-key.service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxSaveProfileNotificationService } from "../bfx-common/services/bfx-save-profile-notification.service";
import { BfxUserProfileService } from "../bfx-common/services/bfx-user-profile.service";
import { BfxConnectionMonitorAuditService } from "./bfx-connection-monitor-audit.service";

@Component({
  selector: "bfx-connection-monitor-audit",
  templateUrl: "./html/bfx-connection-monitor-audit.html",
  encapsulation: ViewEncapsulation.None,
  providers: [provideBlotter(BfxConnectionMonitorAuditComponent)],
  viewProviders: [BfxBaseBlotterColumnSelectorService],
  standalone: false,
})
export class BfxConnectionMonitorAuditComponent extends BfxBaseBlotter {
  constructor(
    BfxBlotterElement: ElementRef,
    applicationRef: ApplicationRef,
    injector: Injector,
    public service: BfxConnectionMonitorAuditService,
    zone: NgZone,
    _tableDefinitionFactory: ConnectionMonitorAuditTableDefinitionFactory,
    layoutService: GoldenLayoutService,
    translationService: TranslateService,
    blotterFilterService: BfxBlotterFilterService,
    columnSelectorService: BfxBaseBlotterColumnSelectorService,
    profileActionService: ProfilePromiseActionService,
    sysConfigService: SystemConfigPromiseService,
    mouseModifierKeyService: BfxMouseModifierKeyService,
    saveProfileNotificationService: BfxSaveProfileNotificationService,
    public goldenLayoutService: GoldenLayoutService,
    protected userProfileService: BfxUserProfileService,
    protected cd: ChangeDetectorRef,
  ) {
    super(
      BfxBlotterElement,
      applicationRef,
      injector,
      service,
      null,
      zone,
      _tableDefinitionFactory,
      layoutService,
      translationService,
      blotterFilterService,
      null,
      columnSelectorService,
      profileActionService,
      sysConfigService,
      mouseModifierKeyService,
      saveProfileNotificationService,
      userProfileService,
    );
    this.blotterId = "bfx-connection-monitor-audit";
  }

  /**
   * Overriding to remove callback for cntext menu opening
   */
  protected initializeColumnDefinitions(): void {
    super.initializeColumnDefinitions();
    this.gridOptions.onCellContextMenu = null;

    this.gridOptions.api.sizeColumnsToFit();
    this.gridOptions.onGridSizeChanged = () => {
      try {
        this._agGridResetScroll();
      } catch (e) {
        logger.out.warn(
          `${this.constructor.name}.onGridSizeChanged ag-grid private API use failed.`,
        );
      } finally {
        this.gridOptions?.api?.sizeColumnsToFit();
      }
    };
  }

  public getBlotterType(): CubiqTS.BlotterType {
    return CubiqTS.BlotterType.OPSINTERVENTION;
  }

  protected applyColumnDefinitions() {
    super.applyColumnDefinitions();

    this.cd.detectChanges();
  }
}
